import { render, staticRenderFns } from "./DatabaseLiveUsers.vue?vue&type=template&id=b4c2e984&"
import script from "./DatabaseLiveUsers.vue?vue&type=script&lang=js&"
export * from "./DatabaseLiveUsers.vue?vue&type=script&lang=js&"
import style0 from "./DatabaseLiveUsers.vue?vue&type=style&index=0&id=b4c2e984&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports